module.exports = __webpack_public_path__ + "img/Info24px.38bf3f2f.svg";